import { FC } from 'react';
import { Bull } from 'types';
import utils from 'utils';
import { ObjectView, TableView } from 'components/Avaliations';
import { objectIs } from 'object-fn-ts';
import { Stack, Typography } from '@mui/material';

type Props = {
  bull: Bull;
  selectedProof?: any;
  selectedProofData?: any[] | any | { [key: string]: string };
  proofObject?: any;
  hasCarcaca?: boolean;
  carcacaName?: string;
};

/* corte europeu - component rendering */
const ECBullDetails: FC<Props> = ({
  selectedProof,
  selectedProofData,
  bull,
  hasCarcaca,
  carcacaName,
}) => {
  return (
    <>
      {hasCarcaca &&
        selectedProof !== ' ' &&
        carcacaName === selectedProof &&
        utils.segmentFromBullOrBreed(bull) === 'ec' &&
        selectedProofData !== null && (
        <ObjectView data={selectedProofData} title={carcacaName} />
      )}

      {selectedProof !== ' ' &&
        selectedProofData !== null &&
        carcacaName !== selectedProof &&
        utils.segmentFromBullOrBreed(bull) === 'ec' &&
        Array.isArray(selectedProofData) && (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>
          <TableView data={selectedProofData} />
        </>
      )}
      {selectedProof !== ' ' &&
        selectedProofData !== null &&
        utils.segmentFromBullOrBreed(bull) === 'ec' &&
        objectIs(selectedProofData) &&
        carcacaName === '' && (
        <>
          <Stack
            {...utils.stack.flex.col('flex-start', 'center')}
            spacing={2}
            sx={utils.sx.fw}
          >
            <Typography>{selectedProof}</Typography>
          </Stack>
          <ObjectView data={selectedProofData} />
        </>
      )}
    </>
  );
};

export default ECBullDetails;
